import { TooltipStyles as styles } from "../css/styles";
type TooltipProps = {
    text: string;
    children: React.ReactNode;
    position?: "top" | "bottom" | "left" | "right";
};
  
export const Tooltip = ({
    text,
    children,
    position = "top",
}: TooltipProps) => {
    return (
      <div className={styles.wrapper}>
        {children}
        <span className={`${styles.tooltip} ${styles[position]}`}>
          {text}
        </span>
      </div>
    );
};